import React from 'react';

const Nouns = () => {
  return (
    <div className="gadject-container">
      <div className="gadject-head">What is a Noun (Orúkọ)?</div>

      <div className="gadject-stuff">
        <div className="gadject-body">
          A noun simply is a word that is the name of a person, animal, place, or thing <br />
          For example;
        </div>

        <div className="noun-table-container">
          <div className="adverb -noun">
            <div className="noun-table">
              <p>Bolu</p>
              <p>car</p>
              <p>cow</p>
              <p>dog</p>
              <p>school</p>
              <p>church</p>
              <p>mosque</p>
              <p>hospital</p>
            </div>
            <div className="noun-table">
              <p>Bolu</p>
              <p>ọkọ̀</p>
              <p>màlúù</p>
              <p>ajá</p>
              <p>ilé ìwé</p>
              <p>ṣọọṣi</p>
              <p>mọ́ṣálásí</p>
              <p>ilé ìwòsàn</p>
            </div>
          </div>

          <div className="adverb -noun">
            <div className="noun-table">
              <p>january</p>
              <p>bed</p>
              <p>father</p>
              <p>mother</p>
              <p>shoe</p>
              <p>hand</p>
              <p>yoruba</p>
              <p>gbenga</p>
            </div>
            <div className="noun-table">
              <p>oṣù kínní</p>
              <p>ibùsùn</p>
              <p>bàbá</p>
              <p>iye</p>
              <p>bàtà</p>
              <p>ọwọ́</p>
              <p>yorùbá </p>
              <p>gbenga</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Nouns;
